import { Routes } from '@angular/router';
import { UserComponent } from './features/user/user.component';
import { WelcomeScreenComponent } from './auth/welcome-screen/welcome-screen.component';
import { AdminLoginComponent } from './auth/admin-login/admin-login.component';
import { NurseLoginComponent } from './auth/nurse-login/nurse-login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SecondaryLayoutComponent } from './layouts/secondary-layout/secondary-layout.component';
import { NurseComponent } from './features/nurse/nurse.component';

import { SingleUserComponent } from './features/user/single-user/single-user.component';
import { UserProfileComponent } from './features/user/user-profile/user-profile.component';
import { authGuard } from './core/guard/auth.guard';
import { AddUserComponent } from './features/user/add-user/add-user.component';
import { AddRoleComponent } from './features/roles/add-role/add-role.component';
import { RolesComponent } from './features/roles/roles.component';
import { AddNurseComponent } from './features/nurse/add-nurse/add-nurse.component';
import { ClientComponent } from './features/client/client.component';
import { AddClientComponent } from './features/client/add-client/add-client.component';
import { SingleClientComponent } from './features/client/single-client/single-client.component';
import { SingleNurseComponent } from './features/nurse/single-nurse/single-nurse.component';
import { LeaveListComponent } from './features/leave/leave-list.component';
import { AddLeaveComponent } from './features/leave/add-leave/add-leave.component';
import { InvoiceComponent } from './features/invoice/invoice.component';
import { GenarateInvoiceComponent } from './features/invoice/genarate-invoice/genarate-invoice.component';
import { SingleInvoiceComponent } from './features/invoice/single-invoice/single-invoice.component';
import { NurseProfileComponent } from './features/nurse/nurse-profile/nurse-profile.component';
import { SingleSalaryComponent } from './features/nurse/single-salary/single-salary.component';
import { ClientProfileComponent } from './features/client/client-profile/client-profile.component';
import { AccessDeniedComponent } from './features/access-denied/access-denied.component';
import { NurseCheckinComponent } from './features/nurse/nurse-checkin/nurse-checkin.component';
import { SingleChargesComponent } from './features/client/single-charges/single-charges.component';
import { CheckinComponent } from './features/checkin/checkin.component';
import { DutyRosterComponent } from './features/duty-roster/duty-roster.component';
import { NurseAttendenceComponent } from './features/nurse-attendence/nurse-attendence.component';
import { InvoiceChargesComponent } from './features/client/invoice-charges/invoice-charges.component';
import { WalkInInvoiceComponent } from './features/walk-in-invoice/walk-in-invoice.component';
import { SalaryChargeConfigComponent } from './features/salary-charge-config/salary-charge-config.component';
import { AddProcedureComponent } from './features/procedure/add-procedure/add-procedure.component';
import { ExtraChargesComponent } from './features/extra-charges/extra-charges.component';
import { ProcedureComponent } from './features/procedure/procedure.component';
import { ManualRecordsComponent } from './features/manual-records/manual-records.component';
import { AddManualRecordComponent } from './features/manual-records/add-manual-record/add-manual-record.component';
import { SingleManualRecordComponent } from './features/manual-records/single-manual-record/single-manual-record.component';
import { ExpiredClientsComponent } from './features/client/expired-clients/expired-clients.component';
import { RegisteredClientsReportComponent } from './features/reports/registered-clients-report/registered-clients-report.component';
import { NonRegisteredClientsReportComponent } from './features/reports/non-registered-clients-report/non-registered-clients-report.component';
import { InwardClientsReportComponent } from './features/reports/inward-clients-report/inward-clients-report.component';
import { RegistrationRenewalIncomeComponent } from './features/reports/registration-renewal-income/registration-renewal-income.component';
import { WalkInClientsReportComponent } from './features/reports/walk-in-clients-report/walk-in-clients-report.component';
import { ConsolidatedIncomeReportComponent } from './features/reports/consolidated-income-report/consolidated-income-report.component';
import { LogsComponent } from './features/logs/logs.component';
import { LoginActivityComponent } from './features/login-activity/login-activity.component';
import { AdminControlComponent } from './features/admin-control/admin-control.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    component: WelcomeScreenComponent,
  },
  {
    path: 'admin-login',
    component: AdminLoginComponent,
  },
  {
    path: 'nurse-login',
    component: NurseLoginComponent
  },
  {
    path: 'forgot-password/:userType',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password/:token/:userType',
    component: ResetPasswordComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'users',
        component: UserComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_VIEW'] },
      },
      {
        path: 'users/add-edit',
        component: AddUserComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_CREATE'] },
      },
      {
        path: 'users/add-edit/:id',
        component: AddUserComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_UPDATE'] },
      },
      {
        path: 'user/:id',
        component: SingleUserComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_VIEW'] },
      },
      {
        path: 'user-profile/:id',
        component: UserProfileComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_VIEW'] },
      },
      {
        path: 'roles/add-edit',
        component: AddRoleComponent,
        canActivate: [authGuard],
        data: { permissions: ['ROLE_CREATE'] },
      },
      {
        path: 'roles/add-edit/:id',
        component: AddRoleComponent,
        canActivate: [authGuard],
        data: { permissions: ['ROLE_UPDATE'] },
      },
      {
        path: 'roles',
        component: RolesComponent,
        canActivate: [authGuard],
        data: { permissions: ['ROLE_VIEW'] },
      },
      {
        path: 'nurse',
        component: NurseComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_VIEW'] },
      },
      {
        path: 'nurse/add-edit',
        component: AddNurseComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_CREATE'] },
      },
      {
        path: 'nurse/add-edit/:id',
        component: AddNurseComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_UPDATE'] },
      },
      {
        path: 'nurse/:id',
        component: SingleNurseComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_VIEW'] },
      },
      {
        path: 'nurse/salary/:nurseId/:month/:year',
        component: SingleSalaryComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_VIEW'] },
      },
      {
        path: 'leave',
        component: LeaveListComponent,
        canActivate: [authGuard],
        data: { permissions: ['LEAVE_VIEW'] },
      },
      {
        path: 'leave/add-edit',
        component: AddLeaveComponent,
        canActivate: [authGuard],
        data: { permissions: ['LEAVE_CREATE'] },
      },
      {
        path: 'leave/add-edit/:id',
        component: AddLeaveComponent,
        canActivate: [authGuard],
        data: { permissions: ['LEAVE_UPDATE'] },
      },
      {
        path: 'client',
        component: ClientComponent,
        canActivate: [authGuard],
        data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'client/expired',
        component: ExpiredClientsComponent,
        canActivate: [authGuard],
        data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'client/add-edit',
        component: AddClientComponent,
        canActivate: [authGuard],
        data: { permissions: ['CLIENT_CREATE'] },
      },
      {
        path: 'client/add-edit/:id',
        component: AddClientComponent,
        canActivate: [authGuard],
        data: { permissions: ['CLIENT_UPDATE'] },
      },
      {
        path: 'client/:id',
        component: SingleClientComponent,
        canActivate: [authGuard],
        data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'invoice',
        component: InvoiceComponent,
        canActivate: [authGuard],
        data: { permissions: ['INVOICE_VIEW'] },
      },
      {
        path: 'invoice/add-edit',
        component: GenarateInvoiceComponent,
        canActivate: [authGuard],
        data: { permissions: ['INVOICE_CREATE'] },
      },
      {
        path: 'invoice/add-edit/:id',
        component: GenarateInvoiceComponent,
        canActivate: [authGuard],
        data: { permissions: ['INVOICE_UPDATE'] },
      },
      {
        path: 'invoice/:id',
        component: SingleInvoiceComponent,
        canActivate: [authGuard],
        data: { permissions: ['INVOICE_VIEW'] },
      },
      {
        path: 'duty-roster',
        component: DutyRosterComponent,
        canActivate: [authGuard],
      },
      {
        path: 'nurse-attendence',
        component: NurseAttendenceComponent,
        canActivate: [authGuard],
      },
      {
        path: 'check-in',
        component: CheckinComponent,
        canActivate: [authGuard],
        data: { permissions: ['SHIFT_CREATE'] },
      },
      {
        path: 'salary-charge-config',
        component: SalaryChargeConfigComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_VIEW'] },
      },
      {
        path: 'procedures/add-edit',
        component: AddProcedureComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_CREATE'] },
      },
      {
        path: 'procedures/add-edit/:id',
        component: AddProcedureComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_UPDATE'] },
      },
      {
        path: 'extra-charges',
        redirectTo: 'procedures/add-edit',
        pathMatch: 'full',
      },
      {
        path: 'extra-charges/:id',
        redirectTo: 'procedures/add-edit/:id',
      },
      {
        path: 'procedures',
        component: ProcedureComponent,
        canActivate: [authGuard],
      },
      // Walk-in Extra Charges. Reuses AddProcedureComponent / ProcedureComponent
      // but flips them into walk-in mode via route data so the form collects
      // a manually entered client name and the table filters to walk-in rows.
      {
        path: 'walk-in-extra-charges',
        component: ProcedureComponent,
        canActivate: [authGuard],
        data: { walkIn: true },
      },
      {
        path: 'walk-in-extra-charges/add-edit',
        component: AddProcedureComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_CREATE'], walkIn: true },
      },
      {
        path: 'walk-in-extra-charges/add-edit/:id',
        component: AddProcedureComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_UPDATE'], walkIn: true },
      },
      {
        path: 'manual-records',
        component: ManualRecordsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'manual-records/view/:id',
        component: SingleManualRecordComponent,
        canActivate: [authGuard],
      },
      {
        path: 'manual-records/add-edit',
        component: AddManualRecordComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_CREATE'] },
      },
      {
        path: 'manual-records/add-edit/:id',
        component: AddManualRecordComponent,
        canActivate: [authGuard],
        data: { permissions: ['EXTRA_CHARGES_UPDATE'] },
      },
      {
        path: 'reports/registered-clients',
        component: RegisteredClientsReportComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
        // data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'reports/non-registered-clients',
        component: NonRegisteredClientsReportComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
        // data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'reports/inward-clients',
        component: InwardClientsReportComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
      },
      {
        path: 'reports/income',
        component: RegistrationRenewalIncomeComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
        // data: { permissions: ['CLIENT_VIEW'] },
      },
      {
        path: 'reports/walk-in-clients',
        component: WalkInClientsReportComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
      },
      {
        path: 'reports/consolidated-income',
        component: ConsolidatedIncomeReportComponent,
        canActivate: [authGuard],
        data: { permissions: ['REPORT_VIEW'] },
      },
      {
        path: 'logs',
        component: LogsComponent,
        canActivate: [authGuard],
        data: { permissions: ['USER_VIEW'] },
      },
      {
        path: 'login-activity',
        component: LoginActivityComponent,
        canActivate: [authGuard],
        // Super Admin only - guarded by SESSION_LOG_VIEW permission.
        data: { permissions: ['SESSION_LOG_VIEW'] },
      },
      {
        // Hidden maintenance page — not linked in nav. Open via /admin/admincontrol
        path: 'admincontrol',
        component: AdminControlComponent,
        canActivate: [authGuard],
        data: { permissions: ['NURSE_UPDATE'] },
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'nurse',
    component: SecondaryLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'nurse-profile/:id',
        component: NurseProfileComponent,
      },
      {
        path: 'nurse-profile/check-in/:id',
        component: NurseCheckinComponent,
      },
      {
        path: 'salary/:nurseId/:month/:year',
        component: SingleSalaryComponent
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'client',
    component: SecondaryLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'client-profile/:id',
        component: ClientProfileComponent,
      },
      {
        path: 'charges/:clientId/:month/:year',
        component: SingleChargesComponent
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],

  },
  {
    path: 'invoice/:clientId/:month/:year',
    component: InvoiceChargesComponent,
    canActivate: [authGuard],
  },
  {
    // Walk-in invoices are keyed by the procedure record _id (one walk-in
    // charge per row, no monthly aggregation since there are no shifts).
    path: 'walk-in-invoice/:procedureId',
    component: WalkInInvoiceComponent,
    canActivate: [authGuard],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
